function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { VARIABLE_REGEXP as s, TEXTAREA_POPUP_WIDTH as u, VARIABLE_NODE_NAME as E, CLOSED_VARIABLE_REGEXP as m, PARENTHESES_LENGTH as a, OPENING_PARENTHESES as d, CLOSING_PARENTHESES as p } from "./index.es494.js";
import { VariableState as L } from "./index.es137.js";

var N = function N(e, t) {
  var _e$current;

  var n = String((_e$current = e.current) === null || _e$current === void 0 ? void 0 : _e$current.textContent);
  return n.slice(t, t + a) === d || n.slice(t - a, t) === p;
},
    A = function A(e, t) {
  if (e.current) {
    var n = document.createTreeWalker(e.current, NodeFilter.SHOW_ELEMENT);
    var r = 0;

    for (; n.nextNode() !== null;) {
      var _o$textContent;

      var o = n.currentNode,
          l = ((_o$textContent = o.textContent) === null || _o$textContent === void 0 ? void 0 : _o$textContent.length) || 0;
      if (t >= r && t <= r + l && !N(e, t) && o.nodeName === E) return o;
      r += l;
    }
  }

  return null;
},
    T = function T(e, t) {
  var _e$current2;

  if (!t.current || !((_e$current2 = e.current) !== null && _e$current2 !== void 0 && _e$current2.children)) return 0;
  var n = Array.from(e.current.children),
      r = n.findIndex(function (l) {
    return l === t.current;
  });
  return n.slice(0, r).reduce(function (l, i) {
    var _i$textContent;

    return l + (((_i$textContent = i.textContent) === null || _i$textContent === void 0 ? void 0 : _i$textContent.length) || 0);
  }, 0);
},
    S = function S(e) {
  return e.replace(/[<>]/g, function (t) {
    return t === "<" ? "&lt;" : "&gt;";
  });
},
    c = function c(e) {
  return e.replace(/^{{|}}$/g, "");
},
    _ = function _(e, t) {
  var n = c(e);
  return t.map(function (r) {
    return _objectSpread(_objectSpread({}, r), {}, {
      items: r.items.filter(function (o) {
        return String(o.label).toLocaleLowerCase().indexOf(n.toLocaleLowerCase()) >= 0;
      })
    });
  }).filter(function (r) {
    return !!r.items.length;
  });
},
    f = function f(e) {
  return e.reduce(function (t, n) {
    return [].concat(_toConsumableArray(t), _toConsumableArray(n.items.map(function (r) {
      return String(r.label);
    })));
  }, []);
},
    h = function h(e, t) {
  var r = f(t).some(function (l) {
    return l.toLocaleLowerCase() === c(e).toLocaleLowerCase();
  }),
      o = !!e.match(m);
  return !r || !o;
},
    x = function x(e, t) {
  return e.split(s).filter(Boolean).map(function (n) {
    var r = S(n);
    return n.match(s) && h(n, t) ? "<mark ".concat(L.error, ">").concat(r, "</mark>") : n.match(s) ? "<mark>".concat(r, "</mark>") : "<span>".concat(r, "</span>");
  }).join("").concat(e.endsWith("\n") ? "<br/>" : "");
},
    P = function P(_ref) {
  var e = _ref.activeVariableRef,
      t = _ref.isPopupPositionUnderVariable,
      n = _ref.popupAlignment;
  return !t && n === "right" ? {
    left: "auto",
    right: "0"
  } : e !== null && e !== void 0 && e.current && e.current.parentElement && t ? {
    top: e.current.offsetTop - e.current.parentElement.scrollTop + 18,
    left: e.current.offsetLeft + 13,
    width: u
  } : {};
};

export { T as calculateOffset, P as calculatePopupPositionStyles, _ as filterOptions, f as flatOptions, x as formatValue, A as getVariableByCaretPosition };